<template>
    <header class="header">
        <div class="container">
            <div class="header__container">
                <div class="header__logo">
                    <z-logo :site-dir="`/${this.$root.lang}/`" :lang="`${this.$root.lang}`" :is-index="isIndex"/>
                </div>
                <div class="header__wrapper hide-me--tablet">
                    <navigation-main />
                    <z-site-selector></z-site-selector>
                </div>
                <div class="hide-me--default show-me--tablet">
                    <div class="header__wrapper">
                        <z-site-selector></z-site-selector>
                        <navigation-mobile />
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import NavigationMain from '@/components/NavigationMain'
import NavigationMobile from '@/components/NavigationMobile'

export default {
    name: 'header-layout',
    components: {
        NavigationMain,
        NavigationMobile
    },
    computed: {
        isIndex () {
            const indexPathname = window.location.pathname
            if (indexPathname === '/ru/' || indexPathname === '/en/') return true
        }
    }
}
</script>

<style lang="scss">
.header {
    display: flex;
    height: 108px;
    position: relative;

    @include breakpoint (laptop) {
        height: 100px;
    }

    @include breakpoint (tablet) {
        height: 80px;
    }

    &__container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid $token-colors-black-10;
        height: 100%;
        position: relative;
    }

    &__wrapper {
        padding-left: $token-spacers-s;
        display: flex;
        align-items: flex-start;
        align-self: flex-end;
    }

    &__logo {
        .z-logo__img {
            height: 70px;

            @include breakpoint (laptop) {
                height: 60px;
            }

            @include breakpoint (tablet) {
                height: 50px;
            }

            @include breakpoint (v-tablet) {
                height: 48px;
            }
        }
    }
}
</style>
